import {USER_ROLE_PLAYER, USER_ROLE_EDITOR, USER_ROLE_ADMIN} from '../constants/globalConstants';

const checkAuthorization = (userRoles, allowedRoles) => {
  if (!userRoles) return false;
  for (const role of allowedRoles) {
    if (userRoles[role]) {
      return true;
    }
  }
  return false;
};

const canRead = userRoles => {
  const allowed = [USER_ROLE_PLAYER, USER_ROLE_EDITOR, USER_ROLE_ADMIN];
  return checkAuthorization(userRoles, allowed);
};

const canEdit = userRoles => {
  const allowed = [USER_ROLE_EDITOR, USER_ROLE_ADMIN];
  return checkAuthorization(userRoles, allowed);
};

const canCreate = userRoles => {
  const allowed = [USER_ROLE_ADMIN];
  return checkAuthorization(userRoles, allowed);
};

const canDelete = userRoles => {
  const allowed = [USER_ROLE_ADMIN];
  return checkAuthorization(userRoles, allowed);
};

const canViewAdminStuff = userRoles => {
  const allowed = [USER_ROLE_EDITOR, USER_ROLE_ADMIN];
  return checkAuthorization(userRoles, allowed);
};

export {canRead, canEdit, canCreate, canDelete, canViewAdminStuff};
